import { useState } from "react";
import { api } from "../utils/apiHandler";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const DeleteAccountPopup = ({ setShowPopup }) => {
  const { t } = useTranslation();
  const [checkbox1, setCheckbox1] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const rawHandle = localStorage.getItem("handle");
  const handle = rawHandle ? JSON.parse(rawHandle) : null;

  const handleDelete = async () => {
    if (!checkbox1 || !checkbox2) {
      setError(t("deleteCheckBoxConfirm"));
      return;
    }

    setError("");
    try {
      const res = await api.delete(`/users/${handle.user.id}`);
      if (res.status === 204) {
        localStorage.clear();
        navigate("/");
      }
      toast.success(t("deleteAccountSuccessToast"), {
        position: "bottom-center",
        autoClose: 2000,
        className: "custom-toastify",
        icon: false,
        hideProgressBar: true,
      });
    } catch (error) {
      console.log("Error in deleting account", error);
      setError(t("deleteAccountFailToast"));
    }
  };

  return (
    <div
      onClick={() => setShowPopup(false)}
      className="fixed top-0 left-0 bg-bg-grey/80 h-screen w-screen z-50 flex items-start pt-[10vh] justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[90%] relative max-w-[320px] bg-white85 border-div rounded-[10px] p-3 text-black"
      >
        <h1 className="font-bold text-[#000000] text-20 text-center">
          {t("deleteAccount")}?
        </h1>
        <p className="text-14 mt-4">{t("deleteConfirm")}</p>

        <div className="mt-5 space-y-3">
          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              checked={checkbox1}
              onChange={(e) => setCheckbox1(e.target.checked)}
              className="appearance-none w-5 h-5 border-2 border-black checked:bg-white checked:border-black checked:after:content-['✓'] checked:after:text-black checked:after:text-[12px] checked:after:font-bold checked:after:flex checked:after:items-center checked:after:justify-center"
            />
            <span className="text-14">{t("deleteAccount")}</span>
          </label>

          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              checked={checkbox2}
              onChange={(e) => setCheckbox2(e.target.checked)}
              className="appearance-none w-5 h-5 border-2 border-black checked:bg-white checked:border-black checked:after:content-['✓'] checked:after:text-black checked:after:text-[12px] checked:after:font-bold checked:after:flex checked:after:items-center checked:after:justify-center"
            />
            <span className="text-14">{t("deleteAccount")}</span>
          </label>
        </div>

        {error && <p className="text-red-600 text-xs mt-2">{error}</p>}

        <div className="mt-5 mb-2">
          <button
            onClick={handleDelete}
            className="btn-green !text-[#C11E69] border-2 border-black mx-auto mt-3 cursor-pointer"
          >
            {t("delete")}
          </button>
        </div>

        <div
          className="absolute -top-4 -translate-y-1/2 left-1/2 -translate-x-1/2"
          onClick={() => setShowPopup(false)}
        >
          <img src="/icons/Sangati/cancel.svg" alt="" className="scale-75" />
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountPopup;
